import Layout from '../../../components/layout'
import Head from 'next/head'
import { CMS_NAME, WEATHER_API_KEY } from '../../../lib/constants'
import React from 'react'
import Article from '../../../components/blog/article'
import { Container, Grid } from '@material-ui/core'
import Newsletter from '../../../components/newsletter'
import Wrapper from '../../../components/layout/grid/wrapper'
import BlogListing from '../../../components/blog/listing'
import globalStyles from '../../../styles/global-styles.module.scss'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { fetchPage } from '../../../lib/api'
import Meta from '../../../components/meta'
import NotFound from '../../../components/error/not-found'

const ArticlePage = (props) => {
  const { categorySlug, articleSlug, data, errorCode } = props

  console.log(data[0])
  return (
    <>
      {errorCode !== 200 && (
        <Layout active={'home'}>
          <NotFound />
        </Layout>
      )}
      {errorCode === 200 && (
        <>
          <Meta
            {...data[0].seoMetaData}
            canonicalUrl={
              categorySlug !== 'all-stories'
                ? `${process.env.NEXT_PUBLIC_SITE_URL}/blog/all-stories/${articleSlug}`
                : null
            }
            structuredData={{
              '@context': 'https://schema.org',
              '@type': 'Article',
              author: {
                '@type': 'Person',
                name: data[0].author
                  ? data[0].author.name
                  : 'Wellness Traveller',
              },
              publisher: {
                '@type': 'Organization',
                name: 'Wellness Traveller',
                logo: {
                  '@type': 'ImageObject',
                  url:
                    'https://cdn.wellnesstraveller.co/wellness-traveller-logo.jpg',
                },
              },
              headline: data[0].title,
              image: data[0].featuredImage.url,
              datePublished: data[0].published_at,
              dateModified: data[0].updated_at,
            }}
          />
          <Layout>
            <Article
              categorySlug={categorySlug}
              articleSlug={articleSlug}
              article={data[0]}
            />
            <Wrapper background={'blue'}>
              <Container maxWidth={'lg'}>
                <Grid container spacing={3} justify={'center'}>
                  <Grid item xs={12}>
                    <Container maxWidth={'lg'}>
                      <Grid container spacing={3} justify={'center'}>
                        <Grid item xs={12}>
                          <h2
                            className={`${globalStyles.sectionHeading} ${globalStyles.centered}`}
                          >
                            <span className={globalStyles.tag}>
                              Similar Articles
                            </span>
                            More Great Reads
                          </h2>
                        </Grid>
                      </Grid>
                    </Container>
                    <BlogListing
                      category={{ slug: '' }}
                      columns={3}
                      count={3}
                    />
                  </Grid>
                </Grid>
              </Container>
            </Wrapper>
            <Wrapper background={'white'} withPadding>
              <Container maxWidth={'lg'}>
                <Grid container spacing={3} justify={'center'}>
                  <Grid item xs={12} md={9}>
                    <Newsletter />
                  </Grid>
                </Grid>
              </Container>
            </Wrapper>
          </Layout>
        </>
      )}
    </>
  )
}
export const getServerSideProps = async ({ locale, query, req, res }) => {
  const page = await fetchPage({
    page: 'blog-articles',
    locale,
    params: { slug: query.slug },
  })
  if (page.errorCode !== 200) {
    res.statusCode = page.errorCode !== 500 ? 404 : page.errorCode
  }
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      categorySlug: query.categorySlug,
      articleSlug: query.slug,
      cookie: req.headers.cookie || '',
      ...page,
    },
  }
}
export default ArticlePage
